import { YGETS_ADDRESS_REQUEST } from 'constants/action-types';

export const fetchAddress = postalCode => ({
  type: YGETS_ADDRESS_REQUEST,
  payload: {
    request: {
      baseURL: process.env.REACT_APP_YGETS_API_BASE_URL,
      url: '/api/address',
      method: 'GET',
      params: {
        postalCode
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/actions/common/address.js